// extracted by mini-css-extract-plugin
export default {"card-multi-select":"medical-conditions-module__card-multi-select--tes","cardMultiSelect":"medical-conditions-module__card-multi-select--tes"};